import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    LearningReportSummary,
    listLearningReports,
} from '../services/learningReportService';
import { LoopyAvatar } from '../components/loopy';
import './LearningReportsListPage.css';

const LearningReportsListPage: React.FC = () => {
    const { t, i18n } = useTranslation('learningReport');
    const [items, setItems] = useState<LearningReportSummary[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        listLearningReports()
            .then(setItems)
            .catch((err) => setError((err as Error).message))
            .finally(() => setLoading(false));
    }, []);

    const formatDate = (iso: string) =>
        new Date(iso).toLocaleDateString(i18n.language, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });

    return (
        <div className="learning-reports-page">
            <div className="learning-reports-header">
                <div className="learning-reports-title">
                    <LoopyAvatar size="sm" emotion="book" ariaLabel="Loopy" />
                    <h1>{t('listTitle')}</h1>
                </div>
                <p>{t('listSubtitle')}</p>
            </div>

            {loading && <div className="learning-reports-empty">{t('loading')}</div>}
            {error && <div className="learning-reports-error">{error}</div>}
            {!loading && !error && items.length === 0 && (
                <div className="learning-reports-empty">{t('empty')}</div>
            )}

            <ul className="learning-reports-list">
                {items.map((r) => (
                    <li key={r.id} className={`learning-reports-item${r.readAt ? ' is-read' : ''}`}>
                        <Link to={`/reports/${r.id}`} className="learning-reports-card">
                            <div className="learning-reports-period">
                                {formatDate(r.periodStart)} → {formatDate(r.periodEnd)}
                            </div>
                            <div className="learning-reports-status">
                                {r.status === 'ready' ? t('statusReady') : t(`status_${r.status}`)}
                            </div>
                            {!r.readAt && r.status === 'ready' && (
                                <span className="learning-reports-dot" aria-label={t('unreadBadge')} />
                            )}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LearningReportsListPage;
